export class EndTimeDateFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "string",
            "format": ""
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EndTimeDateFilters.attributeTypeMap;
    }
    constructor() {
    }
}
